export const SUPPORTED_LANGUAGES = ['en', 'pt'] as const
